import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { jsonResponseApi } from 'src/app/model/json-response.model';
import { CommonService } from 'src/app/services/common.service';
import { Globals } from 'src/app/Utils/globals';

@Component({
  selector: 'app-help',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss'],
  providers: [Globals],
})
export class HelpModalComponent implements OnInit, AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<HelpModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public commonService: CommonService,
    private readonly translate: TranslateService,
    private readonly elementRef: ElementRef,
  ) {}

  leftNavigationSections = [
    {
      section: 'dashboard',
      link: 'KB_LIGHTHOUSE_MAIN',
    },
    {
      section: 'configure',
      link: 'KB_CONFIGURE_FOOTER',
    },
    {
      section: 'develop',
      link: 'KB_DEVELOP_FOOTER',
    },
    {
      section: 'release',
      link: 'KB_RELEASE_FOOTER',
    },
    {
      section: 'testing',
      link: 'KB_TESTING_FOOTER',
    },
    {
      section: 'security',
      link: 'KB_SECURITY_FOOTER',
    },
    {
      section: 'publish',
      link: 'KB_PUBLISH_FOOTER',
    },
    {
      section: 'engage',
      link: 'KB_LIGHTHOUSE_MAIN',
    },
    {
      section: 'user_management',
      link: 'KB_USER_MANAGEMENT_FOOTER',
    },
  ];

  vivaEngageLink =
    'https://engage.cloud.microsoft/main/org/nestle.onmicrosoft.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI2NTcxMzE2ODM4NSJ9';
  otherRequestsFormLink =
    'https://nestle.service-now.com/itsp?id=sc_cat_item&sys_id=f035fa173bb0769c941278b693e45aac&sysparm_domain_restore=false&sysparm_stack=no';
  provideProductSuggestionLink =
    'https://nestle.service-now.com/pdc?id=sc_cat_item&sys_id=351098ad1b404d10fe9e43f1b24bcb9c&capability_id=f4bc68d9db230c5097afb7f9f4961910';
  openIncidentLink =
    'https://nestle.service-now.com/itsp?id=nesa_itsp_sc_cat_item&sys_id=09112ccfdb7bbb800f71f9851d9619b6';
  vivaEngageMessage = '';
  otherRequestsMessage = '';
  provideProductSuggestionMessage = '';
  openIncidentMessage = '';
  knowledgeBaseLink = '';

  ngOnInit(): void {
    this.setRedirectionLinkMessages();
  }

  ngAfterViewInit(): void {
    if (this.elementRef.nativeElement.querySelector('.redirect-to-chatbot')) {
      this.elementRef.nativeElement
        .querySelector('.redirect-to-chatbot')
        .addEventListener('click', this.switchToChatbot.bind(this));
    }

    if (
      this.elementRef.nativeElement.querySelector(
        '.knowledge-base-redirection-link',
      )
    ) {
      this.elementRef.nativeElement
        .querySelector('.knowledge-base-redirection-link')
        .addEventListener('click', this.openKnowledgeBaseLink.bind(this));
    }
  }

  setRedirectionLinkMessages() {
    this.vivaEngageMessage = this.translate
      .instant('component.leftNavBar.help-modal.viva-engage-section')
      .replace("href=''", `href=${this.vivaEngageLink}`);
    this.otherRequestsMessage = this.translate
      .instant('component.leftNavBar.help-modal.other-requests-section')
      .replace("href=''", `href=${this.otherRequestsFormLink}`);
    this.provideProductSuggestionMessage = this.translate
      .instant(
        'component.leftNavBar.help-modal.provide-product-suggestion-section',
      )
      .replace("href=''", `href=${this.provideProductSuggestionLink}`);
    this.openIncidentMessage = this.translate
      .instant('component.leftNavBar.help-modal.open-incident-section')
      .replace("href=''", `href=${this.openIncidentLink}`);
  }

  openKnowledgeBaseLink() {
    this.knowledgeBaseLink = this.leftNavigationSections.find(
      (navigationSection) => {
        return navigationSection.section === this.data;
      },
    )?.link;

    this.commonService.getCrossFormUrl(null, this.knowledgeBaseLink).subscribe({
      next: (res: jsonResponseApi) => {
        const lUrl = res.original_response;
        window.open(lUrl);
      },
      error: (error) => {
        this.commonService.apiError(error.status);
      },
    });
  }

  switchToChatbot() {
    this.dialogRef.close('switchToChatbot');
  }

  onCloseDialog() {
    this.dialogRef.close('close');
  }
}
